import React, { useState } from "react";
import { useForm } from "../../hooks/useForm";
import moment from "moment";
import { Calendario } from "../Otros/Calendario";
import { useFetch } from "../../hooks/useFetch";
import "react-datepicker/dist/react-datepicker.css";
import { PlaceholderColumnas } from "../Otros/Placeholder";
import { UrlWs } from "../../utils/Global";

export const InformacionProceso = ({ proceso, setUpdateProceso }) => {
  const [formData, handleInputChange, reset, updateValue] = useForm({
    yearProcess: proceso.yearProcess,
    name: proceso.name,
    fecha1Start: moment(
      proceso.qualificationStages[0].starDate,
      "YYYY-MM-DD"
    ).format("DD-MM-YYYY"),
    fecha1End: moment(
      proceso.qualificationStages[0].endDate,
      "YYYY-MM-DD"
    ).format("DD-MM-YYYY"),
    fecha2Start: moment(
      proceso.qualificationStages[1].starDate,
      "YYYY-MM-DD"
    ).format("DD-MM-YYYY"),
    fecha2End: moment(
      proceso.qualificationStages[1].endDate,
      "YYYY-MM-DD"
    ).format("DD-MM-YYYY"),
    fecha3Start: moment(
      proceso.qualificationStages[2].starDate,
      "YYYY-MM-DD"
    ).format("DD-MM-YYYY"),
    fecha3End: moment(
      proceso.qualificationStages[2].endDate,
      "YYYY-MM-DD"
    ).format("DD-MM-YYYY"),
    fecha4Start: moment(
      proceso.qualificationStages[3].starDate,
      "YYYY-MM-DD"
    ).format("DD-MM-YYYY"),
    fecha4End: moment(
      proceso.qualificationStages[3].endDate,
      "YYYY-MM-DD"
    ).format("DD-MM-YYYY"),
  });

  const {
    yearProcess,
    name,
    fecha1Start,
    fecha1End,
    fecha2Start,
    fecha2End,
    fecha3Start,
    fecha3End,
    fecha4Start,
    fecha4End,
  } = formData;

  const [actualizarProceso, setActualizarProceso] = useState(false);
  const [cargandoDatos, setCargandoDatos] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    setCargandoDatos(true);
    let procesoActualizado = { ...proceso };
    procesoActualizado.yearProcess = yearProcess;
    procesoActualizado.name = name;
    procesoActualizado.qualificationStages[0].starDate = moment(
      fecha1Start,
      "DD-MM-YYYY"
    ).format("YYYY-MM-DD");
    procesoActualizado.qualificationStages[0].endDate = moment(
      fecha1End,
      "DD-MM-YYYY"
    ).format("YYYY-MM-DD");
    procesoActualizado.qualificationStages[1].starDate = moment(
      fecha2Start,
      "DD-MM-YYYY"
    ).format("YYYY-MM-DD");
    procesoActualizado.qualificationStages[1].endDate = moment(
      fecha2End,
      "DD-MM-YYYY"
    ).format("YYYY-MM-DD");
    procesoActualizado.qualificationStages[2].starDate = moment(
      fecha3Start,
      "DD-MM-YYYY"
    ).format("YYYY-MM-DD");
    procesoActualizado.qualificationStages[2].endDate = moment(
      fecha3End,
      "DD-MM-YYYY"
    ).format("YYYY-MM-DD");
    procesoActualizado.qualificationStages[3].starDate = moment(
      fecha4Start,
      "DD-MM-YYYY"
    ).format("YYYY-MM-DD");
    procesoActualizado.qualificationStages[3].endDate = moment(
      fecha4End,
      "DD-MM-YYYY"
    ).format("YYYY-MM-DD");
    delete procesoActualizado.searchName;
    delete procesoActualizado.searchYear;
    delete procesoActualizado._links;
    delete procesoActualizado.prequalifiers;
    delete procesoActualizado.processStatus;
    delete procesoActualizado.qualifyingBoard;
    delete procesoActualizado.comentElimination;
    delete procesoActualizado.createdDate;
    delete procesoActualizado.createdUser;

    for (let i = 0; i < procesoActualizado.qualificationStages.length; i++) {
      delete procesoActualizado.qualificationStages[i].stage;
      procesoActualizado.qualificationStages[i].id_process =
        procesoActualizado.id_process;
    }

    const url =UrlWs+"/process";
    await fetch(url, {
      method: "PUT",
      body: JSON.stringify(procesoActualizado),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        setCargandoDatos(false);
        return response.json();
      })
      .then((datos) => {
        setUpdateProceso(true);
      });
  };

  const CalendarioFecha1Start = () => {
    return (
      <Calendario
        value={fecha1Start}
        name="fecha1Start"
        id="fecha1Start"
        key="fecha1Start"
        className="form-control mb-5"
        updateValue={updateValue}
        handleInputChange={handleInputChange}
      />
    );
  };

  const CalendarioFecha1End = () => {
    return (
      <Calendario
        value={fecha1End}
        name="fecha1End"
        id="fecha1End"
        key="fecha1End"
        className="form-control mb-5"
        updateValue={updateValue}
        handleInputChange={handleInputChange}
      />
    );
  };

  const CalendarioFecha2Start = () => {
    return (
      <Calendario
        value={fecha2Start}
        name="fecha2Start"
        id="fecha2Start"
        key="fecha2Start"
        disabled="false"
        className="form-control mb-5"
        updateValue={updateValue}
        handleInputChange={handleInputChange}
      />
    );
  };

  const CalendarioFecha2End = () => {
    return (
      <Calendario
        value={fecha2End}
        name="fecha2End"
        id="fecha2End"
        key="fecha2End"
        disabled="false"
        className="form-control mb-5"
        updateValue={updateValue}
        handleInputChange={handleInputChange}
      />
    );
  };

  const CalendarioFecha3Start = () => {
    return (
      <Calendario
        value={fecha3Start}
        name="fecha3Start"
        id="fecha3Start"
        key="fecha3Start"
        className="form-control mb-5"
        updateValue={updateValue}
        handleInputChange={handleInputChange}
      />
    );
  };

  const CalendarioFecha3End = () => {
    return (
      <Calendario
        value={fecha3End}
        name="fecha3End"
        id="fecha3End"
        key="fecha3End"
        className="form-control mb-5"
        updateValue={updateValue}
        handleInputChange={handleInputChange}
      />
    );
  };

  const CalendarioFecha4Start = () => {
    return (
      <Calendario
        value={fecha4Start}
        name="fecha4Start"
        id="fecha4Start"
        key="fecha4Start"
        disabled="false"
        className="form-control mb-5"
        updateValue={updateValue}
        handleInputChange={handleInputChange}
      />
    );
  };

  const CalendarioFecha4End = () => {
    return (
      <Calendario
        value={fecha4End}
        name="fecha4End"
        id="fecha4End"
        key="fecha4End"
        disabled="false"
        className="form-control mb-5"
        updateValue={updateValue}
        handleInputChange={handleInputChange}
      />
    );
  };

  return (
    <>
      <form data-kt-search-element="advanced-options-form" className="pt-1 ">
        <div className="row ">
          {cargandoDatos ? (
            <PlaceholderColumnas columnas={3}></PlaceholderColumnas>
          ) : (
            <>
              <div className="col-lg-4 col-sm-12 ">
                <select
                  className="form-select mb-5"
                  onChange={handleInputChange}
                  aria-label="Select example"
                  name="yearProcess"
                  value={yearProcess}
                >
                  <option value={null}>Año del proceso</option>
                  <option value="2020">2020</option>
                  <option value="2021">2021</option>
                  <option value="2022">2022</option>
                  <option value="2023">2023</option>
                  <option value="2024">2024</option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                  <option value="2027">2027</option>
                  <option value="2028">2028</option>
                  <option value="2029">2029</option>
                  <option value="2030">2030</option>
                </select>
              </div>
              <div className="col-lg-8 col-sm-12 ">
                <input
                  type="text"
                  className="form-control mb-5"
                  onChange={handleInputChange}
                  placeholder="nombre proceso"
                  name="name"
                  value={name}
                />
              </div>

              <div className="col-lg-12 col-sm-12 ">
                <div className="row">
                  <div className="col-4">
                    <label htmlFor="" className="form-label mt-4 ">
                    Evaluación Cuatrimestral (Periodo septiembre a diciembre):
                    </label>
                  </div>
                  <div className="col-8">
                    <div className="row">
                      <div className="col-lg-6 col-sm-12 ">
                        <CalendarioFecha1Start />
                      </div>
                      <div className="col-lg-6 col-sm-12 ">
                        <CalendarioFecha1End />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-12 col-sm-12 ">
                <div className="row">
                  <div className="col-4">
                    <label htmlFor="" className="form-label mt-4">
                    Evaluación Cuatrimestral (Periodo enero a abril):
                    </label>
                  </div>
                  <div className="col-8">
                    <div className="row">
                      <div className="col-lg-6 col-sm-12 ">
                        <CalendarioFecha2Start />
                      </div>
                      <div className="col-lg-6 col-sm-12 ">
                        <CalendarioFecha2End />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="row">
                  <div className="col-4">
                    <label htmlFor="" className="form-label mt-4">
                    Precalificación (Periodo septiembre a agosto):
                    </label>
                  </div>
                  <div className="col-8">
                    <div className="row">
                      <div className="col-lg-6 col-sm-12 ">
                        <CalendarioFecha3Start />
                      </div>
                      <div className="col-lg-6 col-sm-12 ">
                        <CalendarioFecha3End />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-12 col-sm-12 ">
                <div className="row">
                  <div className="col-4">
                    <label htmlFor="" className="form-label mt-4">
                      Calificación:
                    </label>
                  </div>
                  <div className="col-8">
                    <div className="row">
                      <div className="col-lg-6 col-sm-12 ">
                        <CalendarioFecha4Start />
                      </div>
                      <div className="col-lg-6 col-sm-12 ">
                        <CalendarioFecha4End />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-12">
                <div className="row">
                  <div className="col-4">
                    <h4
                      className={`mt-4 ${
                        proceso.processStatus === "Eliminado" ||
                        proceso.processStatus === "Cerrado"
                          ? "text-danger"
                          : ""
                      }`}
                    >
                      Estado: {proceso.processStatus}
                    </h4>
                  </div>
                  <div className="col-8">
                    {proceso.processStatus === "Eliminado" ||
                    proceso.processStatus === "Cerrado" ? (
                      <></>
                    ) : (
                      <div className="d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-sm btn-primary px-6"
                          disabled={cargandoDatos ? "disabled" : ""}
                          onClick={handleSubmit}
                        >
                          <i className="fas fa-redo"></i>Actualizar datos
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </form>
    </>
  );
};
